/**
 * TanStack Query hooks for `retargeting-pixel-support`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	retargetingPixelSupportQueryKeys,
	type CreateRetargetingPixelSupportBody,
	type ListRetargetingPixelSupportResponse,
	type RetargetingPixelSupportRow,
} from "./api";

export function useRetargetingPixelSupportList(): UseQueryResult<ListRetargetingPixelSupportResponse, Error> {
	return useQuery({
		queryKey: retargetingPixelSupportQueryKeys.list(),
		queryFn: list,
	});
}

export function useRetargetingPixelSupportCreate(): UseMutationResult<RetargetingPixelSupportRow, Error, CreateRetargetingPixelSupportBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: retargetingPixelSupportQueryKeys.all });
		},
	});
}

export function useRetargetingPixelSupportDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: retargetingPixelSupportQueryKeys.all });
		},
	});
}
